import { makeObservable, observable } from "mobx"
import { Translation } from "models/faq.model"
import { htmlToTextTransform } from "@lib/html"
import { PostElementBackground } from "@serializers/article"

import { BaseModel } from "./base.model"

export class PaymentTipsModel extends BaseModel {
  // @ts-ignore
  constructor(params) {
    super(params)
    makeObservable(this)
  }

  @observable translations = [] as Translation[]
  @observable isPaymentEnabled = true as boolean
  @observable iOSBlocks = [] as Block[]
  @observable androidBlocks = [] as Block[]
  @observable bundleNames = [] as BundleNames[]
  @observable bundles = [] as Bundle[]
  @observable currentTimestamp = (Date.now() / 1000) as number
  @observable backUrl = "" as string

  getPaymentTips = async () => {
    try {
      const {
        translations,
        is_payment_enabled: isPaymentEnabled,
        ios_blocks: iOSBlocks,
        android_blocks: androidBlocks,
        bundle_names: bundleNames = [],
        payment_back_url: backUrl,
      } = await this.Providers.PaymentTipsProvider.find()

      this.applyData({
        translations,
        isPaymentEnabled,
        iOSBlocks,
        androidBlocks,
        bundleNames,
        backUrl,
      })

      await this.getBundles(bundleNames.map((i) => i.name))
    } catch {}
  }

  getBundles = async (bundleNames: string[]) => {
    try {
      const { results } = await this.Providers.PaymentTipsProvider.getBundles(
        bundleNames,
      )
      this.applyData({
        bundles: results.sort((a, b) => a.price - b.price),
        currentTimestamp: Date.now() / 1000,
      })
    } catch {}
  }

  getPaymentUrl = async (bundleName: string, userId: string) => {
    if (!bundleName || !userId) {
      return
    }

    try {
      const {
        pageURL,
      } = await this.Providers.PaymentTipsProvider.getPaymentUrl(
        bundleName,
        userId,
        this.backUrl,
      )
      return pageURL
    } catch {}
  }

  getTemplate = (key: string, simpleText = false) => {
    const find = this.translations.find((template) => template.key === key)
    if (find) {
      return simpleText ? htmlToTextTransform(find.value) : find.value
    }
    return ""
  }

  hydrate = (data: unknown) => {
    // @ts-ignore
    this.applyData({ translations: data?.translations })
    // @ts-ignore
    this.applyData({ isPaymentEnabled: data?.isPaymentEnabled })
    // @ts-ignore
    this.applyData({ iOSBlocks: data?.iOSBlocks })
    // @ts-ignore
    this.applyData({ androidBlocks: data?.androidBlocks })
    // @ts-ignore
    this.applyData({ bundleNames: data?.bundleNames })
    // @ts-ignore
    this.applyData({ bundles: data?.bundles })
    // @ts-ignore
    this.applyData({ backUrl: data?.backUrl })
  }

  serialize = () => {
    return {
      translations: this.translations,
      isPaymentEnabled: this.isPaymentEnabled,
      iOSBlocks: this.iOSBlocks,
      androidBlocks: this.androidBlocks,
      bundleNames: this.bundleNames,
      bundles: this.bundles,
      backUrl: this.backUrl,
    }
  }
}

export interface Block {
  background: PostElementBackground
  Content: string
}

export interface BundleNames {
  name: string
  postfix: string
}

export interface Bundle {
  currency: "RUB"
  description: string
  has_trial: boolean
  name: string
  price: number
  price_trial: number
}
